const timelineElements = [
  {
    id: 4,
    title: 'IT Support / HR Systems Developer',
    location: 'New Way Trucking Ltd.',
    description: [
      'Built a full-stack HR web application from scratch using React, Node.js, and MySQL.',
      'Designed and implemented the complete database schema to support user, task, and document management.',
      'Developed Python tools to streamline internal HR processes and improve operational efficiency.',
      'Configured firewall and security layers to safeguard internal systems and user data.',
      'Provided comprehensive IT support for software and hardware troubleshooting and system maintenance.',
    ],
    date: 'Most Recent Experience',
    icon: 'work',
  },
  {
    id: 1,
    title: 'IT Specialist',
    location: 'Kognitive Sales Solutions, Calgary, Canada',
    description: [
      'Provided technical support to field personnel, troubleshooting company systems, hardware, and software issues.',
      'Actioned and resolved tickets related to compliance requirements and field support requests using JIRA.',
      'Wrote and executed SQL queries to retrieve or update data in company databases.',
      'Utilized Power BI and Power Query for data visualization and analysis.',
      'Collaborated with cross-functional teams to address compliance concerns and implement corrective actions.',
    ],
    buttonText: 'View Projects',
    date: 'April 2024 – April 2025',
    icon: 'work',
  },
  {
    id: 2,
    title: 'Diploma in Information Technology',
    location: 'Southern Alberta Institute of Technology, Calgary',
    description: [
      'Studied Java, JavaScript, SQL, PL/SQL, HTML, CSS, networking, and cybersecurity.',
      'Self-learned additional technologies including React, Socket.io, and Python.',
    ],
    date: 'May 2022 – December 2023',
    icon: 'school',
  },
  {
    id: 3,
    title: 'IT Support Engineer',
    location: 'Hong Kong',
    description: [
      'Provided end-user support for PC hardware, software, and operating systems.',
      'Managed company website and performed user acceptance testing (UAT) with clients.',
      'Administered network infrastructure including IP phone systems and firewall configurations.',
      'Created and managed user accounts in Microsoft 365, Active Directory, and DHCP.',
    ],
    date: 'October 2019 – February 2022',
    icon: 'work',
  },
];

export default timelineElements;
